import {IApiResponse, IHttpService} from "../http-service";
import {rootContainer, TYPE} from "../container/root";
import {IUser} from "../../models/User";
import {injectable} from "inversify";
import {IPlan} from "../../models/Plan";

export interface IStoreFamily {
    parent: IUser,
    children?: IUser[],
    plan: IPlan
}

@injectable()
export default class ParentChildService {

    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);

    async getUserWithParentChildRelations(id: number) {
        const response = await this.httpService.get<IApiResponse<IStoreFamily>>(`/rms-api/child-parent/get-user-with-parent-child-relations/${id}`);
        return response.payload;
    }

    async sendChildrenChanges(selectedMerchantId: number, parentId: number, childrenToRemove: number[], childrenToAdd: number[]) {
        const res = await this.httpService.post<IApiResponse<IStoreFamily>>(`/rms-api/child-parent/process-changes`, {
            selectedMerchantId: selectedMerchantId,
            parentId: parentId,
            childrenToRemove: childrenToRemove,
            childrenToAdd: childrenToAdd
        });
        return res.payload;
    }

}